import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function MemoryFoamPage() {
  const categoryName = "Memory foam";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "TIARA COOL",
      link: "/patent-series-mattress/tiara-cool/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
      name: "ACCOLADE PT",
      link: "/patent-series-mattress/accolade-pt/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Romance-1.png",
      name: "ROMANCE",
      link: "/patent-series-mattress/romance/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Oslo-Plush12.png",
      name: "HEALTHSENSE ET",
      link: "/patent-series-mattress/healthsense-et/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Cover-1000X667.png",
      name: "HARMONY EDGE",
      link: "/harmony-collection/harmony-edge/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Outlast.png",
      name: "OUTLAST",
      link: "/harmony-collection/outlast/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover.png",
      name: "HARMONY ORTHO",
      link: "/harmony-collection/harmony-ortho/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
      name: "POSTURE COMFORT",
      link: "/luxury-collection/posture-comfort/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667.png",
      name: "NATURA LATEX",
      link: "/latex-mattress/natura-latex/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
      name: "POSTURE THERAPY",
      link: "/luxury-collection/posture-therapy/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
      name: "POSTURE CARE",
      link: "/luxury-collection/posture-care/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-visco_PNG.png",
      name: "ORTHO VISCO LX",
      link: "/luxury-collection/ortho-visco-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover-1.png",
      name: "ORTHO LATEX LX",
      link: "/luxury-collection/ortho-latex-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-visco.png",
      name: "ORTHO VISCO",
      link: "/visco-mattress/ortho-visco/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/ortho-Care-ET.png",
      name: "ORTHO CARE ET",
      link: "/ortho-mattress/ortho-care-et/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-care.png",
      name: "ORTHO CARE",
      link: "/ortho-mattress/ortho-care/",
    },
  ];

  const categoryDescription =
    "Memory foam mattresses are a relatively recent but extremely popular addition to the mattress world. Designed to contour to the body’s shape for support and pressure relief, they provide cushy custom comfort and help relieve pressure. <br/><br/>Explore a wide array of handcrafted memory foam mattresses to optimize body recovery and drastically improve sleep quality.";

  return (
    <div>
      <SEO
        title="Memory Foam Mattress | Eclipse International"
        description="Pressure relieving, anti-allergen and temperature sensitive for a comfortable, durable sleeping experience. Explore the pure memory foam mattress range from Eclipse."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
